import Warning from './Warning.vue'

export default Warning
